/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export type MenuSectionProps = {
  title?: string;
};

export const MenuSection = defineComponent<MenuSectionProps>({
  name: "MenuSection",
  props: ["title"],
  setup(props, { slots }) {
    const { t } = useLocalization();
    return () => (
      <div class="px-4 pt-5 first:pt-2">
        {props.title ? (
          <div class="px-1 pb-2 text-[11px] font-semibold uppercase tracking-widest text-accent">
            {t(props.title)}
          </div>
        ) : null}
        <div class="divide-y divide-base-content/[0.06] overflow-hidden rounded-2xl border border-base-content/[0.06] bg-base-200/60">
          {slots.default?.()}
        </div>
      </div>
    );
  },
});
